import { useEffect, useState } from "react"
import type { Jid } from "../xmpp/jid"
import { createTypingNotifier } from "./typingNotifier"
import { useChat } from "./useChat"

/**
 * Tells a conversation while we are typing in it. Feed it every draft change
 * and every send; `createTypingNotifier` decides what goes on the wire.
 */
export function useTypingNotifier(peer: Jid | undefined, isEnabled: boolean) {
  const { sendChatState } = useChat()
  const [notifier] = useState(() => createTypingNotifier(sendChatState))

  // biome-ignore lint/correctness/useExhaustiveDependencies: runs per conversation
  useEffect(() => () => notifier.left(), [peer, notifier])

  return {
    onDraftChange: (draft: string) => {
      if (peer && isEnabled) notifier.draftChanged(peer, draft)
    },
    onSent: notifier.sent,
  }
}
